module.exports = __webpack_public_path__ + "img/app_logo_no_text.848e7927.png";